/** Test Plan Detail — Task tab status values only. */

export function normalizeTestPlanTaskStatus(status) {
  return String(status || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");
}

export const TEST_PLAN_OWNER_TYPE_OPTIONS = [
  { value: "qa", label: "QA" },
  { value: "dev", label: "DEV" },
  { value: "pm", label: "PM" },
  { value: "dev_ops", label: "Dev Ops" },
];

export const TEST_PLAN_TASK_STATUS_OPTIONS = [
  { value: "to_do", label: "To Do" },
  { value: "in_progress", label: "In Progress" },
  { value: "testing", label: "Testing" },
  { value: "bug", label: "Bug" },
  { value: "feedback", label: "Feedback" },
  { value: "ready_to_deploy", label: "Ready To Deploy" },
  { value: "waiting_to_confirm", label: "Waiting To Confirm" },
  { value: "done", label: "Done" },
  { value: "done_without_deploy", label: "Done without Deploy" },
  { value: "deployed", label: "Deployed" },
  { value: "hold", label: "Hold" },
  { value: "blocked", label: "Blocked" },
  { value: "cancel", label: "Cancel" },
  { value: "waiting_information", label: "Waiting Information" },
  { value: "waiting_support", label: "Waiting Support" },
];

const LABELS = Object.fromEntries(
  TEST_PLAN_TASK_STATUS_OPTIONS.map((o) => [o.value, o.label]),
);

// Legacy / migrated keys — display only for existing records
const LEGACY_LABELS = {
  draft: "Draft",
  block: "Blocked",
  ready_to_test_sit: "Ready To Test on SIT",
  testing_on_sit: "Testing on SIT",
  ready_to_test_stg: "Ready To Test on STG",
  testing_on_stg: "Testing on STG",
};

const PILL_CLASS = {
  to_do: "pill-todo",
  in_progress: "pill-inprogress",
  testing: "pill-testing",
  bug: "pill-bug",
  feedback: "pill-feedback",
  ready_to_deploy: "pill-ready-deploy",
  waiting_to_confirm: "pill-waiting-information",
  deployed: "pill-deployed",
  done: "pill-done",
  done_without_deploy: "pill-done-without-deploy",
  hold: "pill-hold",
  blocked: "pill-blocked",
  cancel: "pill-cancel",
  waiting_information: "pill-waiting-information",
  waiting_support: "pill-waiting-support",
  block: "pill-blocked",
  draft: "pill-draft",
  ready_to_test_sit: "pill-readytest-sit",
  testing_on_sit: "pill-readytest-sit",
  ready_to_test_stg: "pill-readytest-stg",
  testing_on_stg: "pill-readytest-stg",
};

export function testPlanTaskStatusLabel(status) {
  const key = normalizeTestPlanTaskStatus(status);
  if (!key) return "—";
  if (LABELS[key]) return LABELS[key];
  if (LEGACY_LABELS[key]) return LEGACY_LABELS[key];
  return key
    .split("_")
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}

export function testPlanTaskStatusPillClass(status) {
  const key = normalizeTestPlanTaskStatus(status);
  return PILL_CLASS[key] || "pill-inactive";
}

/** Map Test Run display status → Task tab status when task is linked to a run. */
export function taskStatusFromTestRunStatus(runStatus) {
  const key = String(runStatus || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");
  if (key === "not_started") return "to_do";
  if (key === "in_progress") return "testing";
  if (key === "completed" || key === "done") return "done";
  if (key === "aborted" || key === "failed") return "bug";
  return "to_do";
}
